import { BaseModuleObject } from "../frameworkObjects/BaseModuleObject";

export class ModuleObject extends BaseModuleObject {}
